namespace SorAraBul.PropertyManagement {
    export interface TenantDetailHasoRequest extends Serenity.ServiceRequest {
        EntityId?: string;
    }
}
